import { getBalanceSheetMonthly } from "@/services/balance-sheet-monthly";
import { BalanceSheetMonthlyData } from "@/types/balance-sheet-monthly.api";
import { callApiWithChecks } from "./use-template";
import { FULL_YEAR_MONTHS } from "@/lib/time_utils";

export function useBalanceSheetMonthly(
    clientId: string,
    connectionId: string,
    months: number[],
    year: number,
    enabled: boolean
) {
    const monthsKey = months.length ? months.join(',') : FULL_YEAR_MONTHS.join(',');
    return callApiWithChecks<BalanceSheetMonthlyData>(
        () => getBalanceSheetMonthly(clientId, [connectionId], months, year),
        [clientId, connectionId, monthsKey, year],
        enabled,
        { title: 'Error', description: 'Failed to load balance sheet monthly' }
    );
}